import React, {
  createContext,
  useContext,
  ReactNode,
} from "react";
import { useWidgetContext } from "./WidgetProvider";
import { en } from "../i18n";


interface I18nContextType {
  t: (key: keyof TranslationKeys, params?: Record<string, string | number>) => string;
  tHtml: (key: keyof TranslationKeys, params?: Record<string, string | number>) => { __html: string };
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { config } = useWidgetContext();

  const t = (key: keyof TranslationKeys, params?: Record<string, string | number>): string => {
    const raw = config?.translationKeys?.[key] ?? en[key] ?? key;
    if (!params) return raw;
    return Object.entries(params).reduce(
      (str, [k, v]) => str.replace(new RegExp(`\\{${k}\\}`, "g"), String(v)),
      raw,
    );
  };

  const tHtml = (key: keyof TranslationKeys, params?: Record<string, string | number>) => ({
    __html: t(key, params),
  });

  return (
    <I18nContext.Provider value={{ t, tHtml }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used within an I18nProvider");
  }
  return context;
};
